module.exports = __webpack_public_path__ + "static/media/wonderland-family-graphic.3ad70c19.png";